
import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import * as Widgets from 'formiojs/widgets';

import { Formio } from 'formiojs'
if (environment.production) {
  enableProdMode()
}



console.log("widget loaded", Widgets.default.calendar.defaultSettings);

let x = Formio as any;

const DEFAULT_FORMAT = 'MM/dd/yyyy hh:mm a';
const ISO_8601_FORMAT = 'MM/dd/yyyyTHH:mm:ssZ';


Object.defineProperty(Widgets.default.calendar, "defaultSettings", {
    // only returns odd die sides
    get: function () {
        return {
            type: 'calendar',
            altInput: true,
            allowInput: true,
            clickOpens: true,
            enableDate: true,
            enableTime: true,
            mode: 'single',
            noCalendar: false,
            format: DEFAULT_FORMAT,
            dateFormat: ISO_8601_FORMAT,
            useLocaleSettings: false,
            language: 'us-en',
            hourIncrement: 1,
            minuteIncrement: 5,
            time_24hr: false,
            saveAs: 'date',
            displayInTimezone: '',
            timezone: '',
            disable: [],
            minDate: '',
            maxDate: ''
        }

    }
});







const dateTimeSchema = x.Components.components.datetime?.schema;
if (dateTimeSchema) {
    x.Components.components.datetime.schema = (...extend) => {
        let schema = dateTimeSchema(extend);
        schema.format = DEFAULT_FORMAT;
        return schema;
    };
}



platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err))
